/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function DesktopIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M34 7H6c-.562 0-1 .5-1 1v12h30V8c0-.5-.5-1-1-1m4 13v6c0 2.25-1.812 4-4 4h-9.25l.5 3h3.25c.813 0 1.5.688 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-17c-.875 0-1.5-.625-1.5-1.5 0-.812.625-1.5 1.5-1.5h3.188l.5-3H6c-2.25 0-4-1.75-4-4V8c0-2.187 1.75-4 4-4h28c2.188 0 4 1.813 4 4zM5 23v3c0 .563.438 1 1 1h28c.5 0 1-.437 1-1v-3zm12.75 10h4.438l-.5-3H18.25z"/>}
        </IconWrapper>);
}
